import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

// The OpenAI models offered for AI help on the Jobs settings: the ones the user's own OpenAI key can use, or a short list of
// well known ones when OpenAI could not be asked (`live` says which). Loaded when the AI section is opened, and kept for the visit.
export const useJobAiStore = defineStore('jobAi', {
  state: () => ({
    models: [], // [{ id, label, default, pricing }]: pricing is dollars per million tokens ({ input, cached_input, output }), or null
    pricesAsOf: null, // the day those prices were checked
    live: true,
    loaded: false,
    loading: false,
    error: null,
  }),

  actions: {
    async fetchModels() {
      if (this.loading) return

      this.loading = true
      this.error = null
      const { axiosRequest } = useRequest()
      let res
      try {
        res = await axiosRequest('GET', '/api/v1/job_ai_models', {}, false)
      } catch {
        res = { js_error: true }
      }
      if (!res.js_error && res.response?.success) {
        this.models = res.response.data.models
        this.live = res.response.data.live
        this.pricesAsOf = res.response.data.prices_as_of || null
        this.loaded = true
      } else {
        this.error = res.response?.message || res.error?.data?.message || 'Could not load the OpenAI models.'
      }
      this.loading = false
    },
  },
})
